<template>
    <v-container fluid>

        <!-- Filtro data -->
        <v-row dense class="mb-2">
            <v-col cols="12" sm="6" md="4" class="gestione-filters">
                <label class="d-block mb-1">Data Specifica</label>
                <v-menu v-model="calendarData"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="viewData" prepend-icon="mdi-calendar" readonly v-on="on" outlined dense hide-details/>
                    </template>
                    <v-date-picker v-model="data" @input="changeData"/>
                </v-menu>
            </v-col>
        </v-row>

        <!-- Per ogni giornata -->
        <div v-for="(date, index) in listDate" :key="index" class="mb-4">
            <h4 class="assoc-date-title">{{ date.viewData }}</h4>

            <!-- Desktop: tabella -->
            <v-simple-table v-if="!$vuetify.breakpoint.xsOnly" class="content-table associati">
                <thead>
                <tr>
                    <th class="text-left">Operatore</th>
                    <th class="text-left">Lavori</th>
                    <th class="text-left">Tempo stimato</th>
                    <th class="text-left"/>
                </tr>
                </thead>
                <tbody>
                <tr v-for="operatore in date.operatori" :key="operatore._id">
                    <td>
                        <i class="fas fa-circle" style="font-size: 14px !important;" :style="{ color: operatore.rHexColor + '!important' }"/>
                        {{ operatore.rName }}
                    </td>
                    <td>{{ operatore.rCompletate }} / {{ operatore.rNumeroPrese }}</td>
                    <td>
                        <span v-if="operatore.rOrePreviste !== '00:00'">{{ operatore.rOrePreviste }}</span>
                    </td>
                    <td class="text-right">
                        <router-link :to="{ path: '/utente', query: { _id: operatore._id} }" v-if="action === 'lista'">
                            <button type="button" name="button" class="button primary">
                                <i class="fas fa-list"/>
                                <span>Lista</span>
                            </button>
                        </router-link>
                        <div v-if="action === 'associa'">
                            <button v-if="!operatore.rAssegnato || date.data !== operatore.rDateAssociato"
                                    type="button" name="button" class="button primary"
                                    @click="assegna(date.data, operatore._id)"
                            >
                                <i class="fas fa-arrow-circle-right"/>
                                <span>Assegna</span>
                            </button>
                            <button type="button" name="button" class="button primary" v-else>
                                <span>Assegnato</span>
                            </button>
                        </div>
                    </td>
                </tr>
                </tbody>
            </v-simple-table>

            <!-- Mobile: card -->
            <div v-else>
                <v-card v-for="operatore in date.operatori" :key="operatore._id"
                        class="assoc-card mb-2 rounded-lg">
                    <v-card-text class="pa-3">
                        <div class="assoc-card__row">
                            <div class="assoc-card__operatore">
                                <i class="fas fa-circle assoc-card__dot"
                                   :style="{ color: operatore.rHexColor }"/>
                                <strong>{{ operatore.rName }}</strong>
                            </div>
                            <div class="assoc-card__meta">
                                <span class="assoc-card__label">Lavori:</span>
                                <span class="ml-1">{{ operatore.rCompletate }} / {{ operatore.rNumeroPrese }}</span>
                                <span v-if="operatore.rOrePreviste && operatore.rOrePreviste !== '00:00'" class="ml-3">
                                    <span class="assoc-card__label">Tempo:</span>
                                    <span class="ml-1">{{ operatore.rOrePreviste }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="assoc-card__action mt-2">
                            <router-link :to="{ path: '/utente', query: { _id: operatore._id} }" v-if="action === 'lista'">
                                <button type="button" name="button" class="button primary assoc-btn">
                                    <i class="fas fa-list"/>
                                    <span>Lista</span>
                                </button>
                            </router-link>
                            <div v-if="action === 'associa'">
                                <button v-if="!operatore.rAssegnato || date.data !== operatore.rDateAssociato"
                                        type="button" name="button" class="button primary assoc-btn"
                                        @click="assegna(date.data, operatore._id)"
                                >
                                    <i class="fas fa-arrow-circle-right"/>
                                    <span>Assegna</span>
                                </button>
                                <button type="button" name="button" class="button primary assoc-btn" v-else>
                                    <span>Assegnato</span>
                                </button>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </div>
        </div>

    </v-container>
</template>
<script>
import {momentLL, momentYMD} from "@/components/js/formatDate";
import apiPresa from '@/components/Presa/js/presa';
import apiLavorazioni from '@/components/Presa/lavorazioni/js/lavorazioni';
import {generalFunction} from "@/components/js/generalFunction";
import {EventBus} from "@/eventBus";

export default {
    name: 'Associati',
    props: [
        'action',
        'days'
    ],
    data() {
        return {
            idPresa: this.$route.query._id,
            data: momentYMD(new Date),
            viewData: momentLL(new Date),
            calendarData: false,
            presa: {},
            listDate: [],
            prese: [],
            allLavorazioni: [],
            value: [new Date()],
            events: [],
            weekday: [2, 3, 4, 5, 6],
            type: 'month'
        }
    },
    async created() {
        let token = await generalFunction.getToken();
        if (token) {
            let lavorazioni = await apiLavorazioni.getAllLavorazioni(token);
            if (lavorazioni[1])
                this.allLavorazioni = lavorazioni[1];

            if (this.idPresa) {
                this.presa = await apiPresa.getPresaWithDetails(token, this.idPresa);
            }
        }

        await this.initSearch();

        //this.getEvents(new Date(), new Date());
    },
    methods: {
        /*getEvents() {
            const events = []

            if (this.prese.length) {
                //for (let presa of this.prese) {
                    events.push({
                        name: 'Presa #4756',
                        start: new Date(),
                        color: '',
                        allDay: true,
                    })
                //}
            }

            this.events = events
        }, */
        changeData() {
            this.calendarData = false;
            this.viewData = momentLL(this.data);
            this.initSearch();
            //this.getEvents();
            //this.value = this.data;
        },
        async initSearch() {
            this.prese = this.listDate = [];
            let token = await generalFunction.getToken();
            if (token) {
                let data = {
                    data: this.data,
                    days: this.days
                };
                this.listDate.push({
                    data: momentYMD(this.data),
                    viewData: momentLL(this.data),
                });

                for (let day = 1; day < this.days; day++) {
                    this.listDate.push({
                        data: momentYMD(generalFunction.addDays(new Date(this.data), day)),
                        viewData: momentLL(generalFunction.addDays(new Date(this.data), day))
                    });
                }

                let listPrese = await apiPresa.getPreseAssociate(token, data);
                if (
                    listPrese &&
                    listPrese[0]
                ) this.prese = listPrese[0];
                await this.controlOperatori();
            }
        },
        async controlOperatori() {
            let token = await generalFunction.getToken();
            if (token) {
                let operatori = await generalFunction.getOperatori(token);
                if (
                    operatori &&
                    operatori.length > 0
                ) {
                    for (let [index, data] of this.listDate.entries()) {
                        data.operatori = [];
                        for (let operatore of operatori) {
                            operatore.rName = '';
                            if (operatore.nome)
                                operatore.rName += operatore.nome;

                            operatore.rHexColor = '#ccc';
                            if (operatore.colore)
                                operatore.rHexColor = operatore.colore;

                            operatore.rNumeroPrese = 0;
                            operatore.rCompletate = 0;
                            operatore.rOreStimate = '00:00';

                            let prese = this.prese.filter((obj) => obj.operatore_associato === operatore._id);
                            if (prese) {
                                operatore.rOrePreviste = '00:00';
                                for (let presa of prese) {
                                    if (
                                        presa.lavorazioni &&
                                        data.data &&
                                        presa.data_lavoro &&
                                        data.data === momentYMD(presa.data_lavoro)
                                    ) {
                                        if(presa.ore_reali)
                                            operatore.rOreOccupate = generalFunction.sumHours(operatore.rOreOccupate, presa.ore_reali, ':');

                                        if(presa.tempo_previsto)
                                            operatore.rOrePreviste = generalFunction.sumHours(operatore.rOrePreviste, presa.tempo_previsto, ':');

                                        operatore.rNumeroPrese = operatore.rNumeroPrese + 1;
                                        if (presa.completata) operatore.rCompletate = operatore.rCompletate +1;
                                        if (
                                            operatore._id === presa.operatore_associato &&
                                            presa._id === this.idPresa
                                        ) {
                                            operatore.rAssegnato = true;
                                            operatore.rDateAssociato = momentYMD(presa.data_lavoro);
                                        }
                                    }
                                }
                            }
                            data.operatori.push({ ...operatore });
                        }
                        this.$set(this.listDate, index, data);
                    }
                }
            }
        },
        async assegna(dataLavoro, idOperatore) {
            let token = await generalFunction.getToken();
            if (token) {
                if (
                    dataLavoro &&
                    idOperatore &&
                    this.$route.query &&
                    this.$route.query._id
                ) {
                    let data = {
                        id_presa: this.$route.query._id,
                        id_operatore: idOperatore,
                        data_lavoro: dataLavoro
                    };
                    await apiPresa.assegnaOperatore(token, data).then(response => {
                        if (response) {
                            this.initSearch();
                            EventBus.$emit('reloadDetailPresa');
                        } else alert('Spiacenti si è verificato un errore');
                    });
                }
            }
        }
    }
}
</script>

<style scoped>
.assoc-date-title {
    background-color: #eee;
    padding: 5px 0 5px 12px;
    margin-bottom: 8px;
}

.assoc-card {
    border: 1px solid #dae3e8;
}

.assoc-card__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
}

.assoc-card__operatore {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #505d68;
}

.assoc-card__dot {
    font-size: 12px !important;
}

.assoc-card__meta {
    font-size: 13px;
    color: #505d68;
}

.assoc-card__label {
    font-weight: 700;
    font-size: 11px;
    text-transform: uppercase;
    color: #a0a5ac;
}

.assoc-card__action {
    display: flex;
}

.assoc-btn {
    display: flex;
    color: white;
    padding: 4px 14px;
    border-radius: 25px;
    text-transform: uppercase;
    min-width: auto !important;
}

.assoc-btn i {
    color: white !important;
    font-size: 16px !important;
    padding-right: 6px;
}

.assoc-btn span {
    margin-top: 2px;
}
</style>